import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import GalleryGrid from "@/components/GalleryGrid";

export default function Gallery() {
  return (
    <>
      <SEO title="Gallery" description="A look inside Chopstick Chinese Corner — the food, the wok, the room. Sector xxx, Gurugram." />
      <PageHero
        overline="Gallery"
        titleLines={["Look", "before you", "taste."]}
        subtitle="A peek at the plates, the steamers and the warm little corner we've built. Photography shown is licensed placeholder imagery until our own is ready."
      />
      <section className="mx-auto max-w-7xl px-5 md:px-8 py-16 md:py-24">
        <Reveal>
          <GalleryGrid />
        </Reveal>
      </section>
    </>
  );
}
